import Vue from 'vue'
import lodash from 'lodash'
import types from '@/store/mutation-types'
import * as purchasesApi from '@/api/purchases/request'

/**
 * @typedef {Object} State
 * @prop {string[]} pr
 * @prop {string[]} po
 * @prop {string[]} pc
 */
/**
 * @type {State}
 */
const defaultState = {
  pr: [],
  po: [],
  pc: [],
}

/**
 * State Getters
 */
const getters = {
  pr: state => state.pr,
  po: state => state.po,
  pc: state => state.pc,
}

/**
 * State Actions
 */
const actions = {
  async loadPurchaseCurrencies ({ commit }) {
    const apiMap = [
      ['pr', purchasesApi.getPrCurrencies],
      ['pc', purchasesApi.getPcCurrencies],
      ['po', purchasesApi.getPoCurrencies],
    ]
    await Promise.all(apiMap.map(async ([type, api]) => {
      const { data: result } = await api()
      commit(types.UPDATE_CURRENCIES, { currencies: result, type })
    }))
  },
}

/**
 * State Mutations
 */
const mutations = {
  [types.UPDATE_CURRENCIES] (state, { currencies, type }) {
    Vue.set(state, type, currencies)
  },
  [types.LOGOUT_RESET_STATE] (state) {
    Object.keys(defaultState).forEach(key => {
      Vue.set(state, key, defaultState[key])
    })
  },
}

export default {
  namespaced: true,
  state: lodash.cloneDeep(defaultState),
  getters,
  actions,
  mutations,
}
